import { tns } from 'tiny-slider/src/tiny-slider'
import 'tiny-slider/dist/tiny-slider.css'

const $sliders = document.querySelectorAll('.image-slider-panel')

const fn = {
  init: () => {
    $sliders.forEach(($el) => {
      fn.setupImageSlider($el)
    })
  },

  setupImageSlider: ($el) => {
    const $slider = $el.querySelector('.image-slider')

    if (!$slider) {
      return
    }

    const mainSlider = tns({
      container: '.image-slider',
      items: 1,
      slideBy: 'page',
      nav: false,
      controlsText: ['', ''],
      autoplay: true,
      autoplayHoverPause: true,
      autoplayButtonOutput: false,
    })

    const captionSlider = tns({
      container: '.image-slider-bottom',
      items: 1,
      mode: 'gallery',
      slideBy: 'page',
      touch: false,
      nav: false,
      controls: false,
    })

    mainSlider.events.on('indexChanged', () => {
      captionSlider.goTo(mainSlider.getInfo().displayIndex - 1)
    })
  },
}

export default {
  can: () => $sliders.length,
  run: fn.init,
}
